import { CandidateInterviewPageStages } from '@/types';
import { InterviewTypes } from '@/utils/interviews';
import * as Styles from './CandidateInterviewHeader.styles';

export type CandidateInterviewHeaderProps = {
  candidateName: string;
  interviewType: InterviewTypes;
  interviewState: CandidateInterviewPageStages;
};

export const interviewTitle = {
  [InterviewTypes.PRE_SCREENING]: 'Pre-Screening Interview',
  [InterviewTypes.TECHNICAL_CHALLENGE]: 'Technical Challenge',
};

export default function CandidateInterviewHeader({
  candidateName,
  interviewState,
  interviewType,
}: CandidateInterviewHeaderProps): JSX.Element {
  return (
    <Styles.Header>
      <Styles.Container>
        <Styles.HeaderLogo href="https://www.trio.dev/" target="_blank">
          Trio
        </Styles.HeaderLogo>

        <Styles.CandidateInfoHeader>
          <Styles.InterviewStage>{interviewTitle[interviewType]}</Styles.InterviewStage>

          {interviewState !== CandidateInterviewPageStages.WELCOME && (
            <Styles.CandidateName>{candidateName}</Styles.CandidateName>
          )}
        </Styles.CandidateInfoHeader>
      </Styles.Container>
    </Styles.Header>
  );
}
